module.exports = __webpack_public_path__ + "sheep3.34aceed9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/content/sheep3.svg
 ** module id = 113
 ** module chunks = 0
 **/